<template>
    <v-container fill-height>

        <v-row>
            <v-col cols="12" lg="8" md="8">
                <v-btn color="primary" class="ma-3" @click="closeWindow">
                    Close this popup
                </v-btn>
            </v-col>
            <v-col cols="12" lg="3" md="3">

                <v-text-field label="Incident"
                              v-model="incidentId"
                              placeholder="Incident"
                              prepend-inner-icon="mdi-magnify"></v-text-field>


            </v-col>
            <v-col cols="12" lg="1" md="1">

                <v-btn block color="primary" class="ma-3" @click="lookupPostSevDetails">
                    Lookup
                </v-btn>
            </v-col>
        </v-row>

        <v-skeleton-loader class="mb-4" type="image" v-show="isSevImpactBusy" width="100%"></v-skeleton-loader>

        <sev-impact :data="sevImpactDetails" v-show="!isSevImpactBusy"></sev-impact>

        <v-skeleton-loader class="mb-4" type="image" v-show="isSevImpactLogBusy" width="100%"></v-skeleton-loader>

        <sev-impact-log :data="sevImpactLogDetails" v-show="!isSevImpactLogBusy"></sev-impact-log>

        <v-skeleton-loader type="image" v-show="isSevImpactLogBusy" width="100%"></v-skeleton-loader>

        <post-sev :data="postSevDetail" :pie-data="pieData" v-show="!isBusy"></post-sev>

        <v-row>
            <v-col cols="12" md="8" lg="8">
                <elastic-info :data="elasticInfoDetails" v-show="!isElasticInfoBusy"></elastic-info>
                <v-skeleton-loader type="image" v-show="isElasticInfoBusy" width="100%" class="mt-4"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="4" lg="4">
                <incident-report :data="postSevDetail" v-show="!isBusy"></incident-report>
                <v-skeleton-loader type="image" v-show="isBusy" width="100%" class="mt-4"></v-skeleton-loader>
            </v-col>
        </v-row>

        <pager-duty :data="pagerDutyDetails" v-show="!isPagerDutyBusy"></pager-duty>

        <v-skeleton-loader type="image" v-show="isPagerDutyBusy" width="100%" class="mt-4"></v-skeleton-loader>

        <remedy-details :data="remedyDetails" v-show="!isRemedyDetailsBusy"></remedy-details>

        <v-skeleton-loader type="image" v-show="isRemedyDetailsBusy" width="100%" class="mt-4"></v-skeleton-loader>

    </v-container>
</template>

<script>
    import ReportService from "../../services/reportService"
    import SevImpact from "../../components/reports/SevImpact"
    import IncidentReport from "../../components/reports/IncidentReport"
    import RemedyDetails from "../../components/reports/RemedyDetails"
    import PagerDuty from "../../components/reports/PagerDuty"
    import PostSev from "../../components/reports/PostSev"
    import ElasticInfo from "../../components/reports/ElasticInfo"
    import SevImpactLog from "../../components/reports/SevImpactLog"
    import { EventBus } from '../../event/event-bus.js';

    export default {
        name: 'HighSevExecReport',
        data: function () {
            return {
                isBusy: true,
                isSevImpactBusy: true,
                isSevImpactLogBusy: true,
                isElasticInfoBusy: true,
                isPagerDutyBusy: true,
                isRemedyDetailsBusy: true,
                accessToken: null,
                postSevDetail: {},
                pieData: [],
                incidentId: "",
                sevImpactDetails: null,
                sevImpactLogDetails: [],
                elasticInfoDetails: {},
                pagerDutyDetails: {},
                remedyDetails: {},
            }
        },
        components: {
            SevImpact,
            SevImpactLog,
            ElasticInfo,
            PostSev,
            IncidentReport,
            PagerDuty,
            RemedyDetails
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                this.incidentId = this.$route.params.id;

                if (this.incidentId) {
                    await this.getPostSevByIncidentId();
                    await this.getSevImpactByIncidentId();
                    await this.getSevImpactLogByIncidentId();
                    await this.getElasticInfoByIncidentId();
                    await this.getPagerDutyByIncidentId();
                    await this.getRemedyDetailsByIncidentId();
                }
            },
            async getSevImpactByIncidentId() {
                this.isSevImpactBusy = true;

                this.sevImpactDetails = {};

                const result = await ReportService.getSevImactDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.sevImpactDetails = result;
                }

                this.isSevImpactBusy = false;
            },
            async getSevImpactLogByIncidentId() {
                this.isSevImpactLogBusy = true;

                this.sevImpactLogDetails = [];

                const result = await ReportService.getSevImactLogDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.sevImpactLogDetails = result;
                }

                this.isSevImpactLogBusy = false;
            },
            async getPagerDutyByIncidentId() {
                this.isPagerDutyBusy = true;

                this.pagerDutyDetails = {};

                const result = await ReportService.getPagerDutyDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.pagerDutyDetails = result;
                }

                this.isPagerDutyBusy = false;
            },
            async getRemedyDetailsByIncidentId() {
                this.isRemedyDetailsBusy = true;

                this.remedyDetails = {};

                const result = await ReportService.getRemedyDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.remedyDetails = result;
                }

                this.isRemedyDetailsBusy = false;
            },
            async getPostSevByIncidentId() {
                this.isBusy = true;
                this.postSevDetail = {};

                this.pieData = [];

                const result = await ReportService.getPostSevDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.pieData.push({ name: "MTTC", value: result.mttcMinutes });
                    this.pieData.push({ name: "MTTR", value: result.mttrMinutes });
                    this.postSevDetail = result;
                }
                else {
                    EventBus.$emit('emit-info', "Incident not found or you do not have permission to view it.");
                }
                this.isBusy = false;
            },
            async getElasticInfoByIncidentId() {
                this.isElasticInfoBusy = true;

                this.elasticInfoDetails = {};

                const result = await ReportService.getElasticInfoDetailsByIncidentId(this.incidentId, this.accessToken);

                if (result) {
                    this.elasticInfoDetails = result;
                }

                this.isElasticInfoBusy = false;
            },
            async lookupPostSevDetails() {
                if (this.incidentid) {
                    this.$router.replace(`/highSevDetails/${this.incidentId}`)
                    this.postSevDetail = {};
                    this.pieData = [];

                    this.isBusy = true;
                    const result = await ReportService.getPostSevDetailsByIncidentId(this.incidentId, this.accessToken);

                    if (result) {
                        this.pieData = []
                        this.pieData.push({ name: "MTTC", value: result.mttcMinutes });
                        this.pieData.push({ name: "MTTR", value: result.mttrMinutes });
                        this.postSevDetail = result;
                    }
                    else {
                        EventBus.$emit('emit-info', "Incident not found or you do not have permission to view it.");
                    }

                    this.isBusy = false;
                }
            },
            closeWindow() {
                window.close();
            }
        },
        created() {
            this.setup();
        }
    }
</script>
